import {
  Tag,
  Theme,
  NextgenImage,
  TagStyle,
  IconStyle,
  ProgressTracker,
  useTranslation,
  LoaderType,
} from '@nextgen-web-framework/all';
import ProductThumbnailCard from '../product-thumbnails-card/ProductThumbnailCard';
import styles from './DeliveryPackageCard.module.scss';
import { DeliveryPackageCardProps } from './types/propsTypes';

const DeliveryPackageCard = (props: DeliveryPackageCardProps) => {
  const t = useTranslation();
  const { packageLable, orderId, orderTrackingNote, productImageUrls, deliveryProgressStages } = props;
  return (
    <div className={styles['delivery-package-card']}>
      <div className={styles['delivery-package-card-header']}>{orderId}</div>
      <div className={styles['delivery-package-card-body']}>
        {packageLable && (
          <div className={styles['delivery-package-card-tag']}>
            <Tag
              text={t('order.deliveryTracking.packageLable').replace('{{count}}', packageLable)}
              style={TagStyle.OUTLINE}
              className={styles['package-tag']}
              theme={Theme.PURPLE}
              icon={{
                iconName: 'box-taped',
                iconStyle: IconStyle.REGULAR,
              }}
            />
          </div>
        )}
        <div className={styles['delivery-package-card-delivery-time']}>{orderTrackingNote}</div>
        <div className={styles['delivery-package-card-product-details']}>
          {props.carrierPartnerLogoUrl && (
            <div className={styles['delivery-package-card-carrier-details']}>
              <span className={styles['delivery-package-card-carrier-title']}>
                {t('order.deliveryTracking.carrierPartner')}
              </span>
              <div className={styles['delivery-package-card-carrier-logo-container']}>
                <NextgenImage src={props.carrierPartnerLogoUrl} loaderType={LoaderType.WEBFONTS} alt={''} />
              </div>
            </div>
          )}
          {productImageUrls && productImageUrls?.length > 0 && (
            <ProductThumbnailCard productImageUrls={productImageUrls} />
          )}
        </div>
        {deliveryProgressStages && (
          <div className={styles['delivery-package-card-progress-tracking']}>
            <ProgressTracker stages={deliveryProgressStages} />
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryPackageCard;
